// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__4RjDQ","name":"Header_name__2psDO","birthday":"Header_birthday__1Zb2n","skeleton":"Header_skeleton__1qseG"};